module.exports = __webpack_public_path__ + "img/bikkurapon_target_cn.80887702.png";